import { createFileRoute, redirect } from "@tanstack/react-router";
import { blackScheduledHref } from "@/lib/black2x1/offer-rules";
import { Black2x1Page } from "@/components/black2x1/Black2x1Page";
import logoOficial from "@/assets/black2x1/black-logo-oficial.webp.asset.json";

const URL = "https://fisioemortopedia.com.br/black-lista";
const OG_IMAGE = `https://fisioemortopedia.com.br${logoOficial.url}`;

export const Route = createFileRoute("/black-lista")({
  beforeLoad: ({ location }) => {
    const destination = blackScheduledHref(location.href, Date.now());
    if (destination !== location.href) throw redirect({ href: destination, statusCode: 302 });
  },
  head: () => ({
    meta: [
      { title: "BLACK FEO 2026 · Pós em Dobro: 2 pós pelo preço de 1" },
      { name: "description", content: "BLACK da FEO 2026: duas pós-graduações em fisioterapia reconhecidas pelo MEC pelo preço de uma, com Star Cursos vitalícia. Entre no grupo e receba a oferta em 26/10." },
      { name: "robots", content: "index,follow,max-image-preview:large" },
      { property: "og:title", content: "BLACK FEO 2026 · Pós em Dobro" },
      { property: "og:description", content: "Duas pós-graduações pelo preço de uma. Entre no grupo oficial e receba a oferta antes de todo mundo." },
      { property: "og:type", content: "website" },
      { property: "og:url", content: URL },
      { property: "og:image", content: OG_IMAGE },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "BLACK FEO 2026 · Pós em Dobro" },
      { name: "twitter:description", content: "Duas pós-graduações pelo preço de uma. Entre no grupo oficial e receba a oferta antes de todo mundo." },
      { name: "twitter:image", content: OG_IMAGE },
    ],
    links: [
      { rel: "canonical", href: URL },
      { rel: "preload", as: "image", href: logoOficial.url, fetchPriority: "high" },
    ],
  }),
  component: () => <Black2x1Page mode="lista" />,
});